/**
 * Bundle cart
 * --------------------------------------------------------------------------
 * When a customer removes ANY line of a bundle, the WHOLE bundle is removed.
 *
 * The remove control in this theme is `<a is="cart-remove-item" data-index>`,
 * whose own click handler (in cart.js) removes a single line. We listen on the
 * document in the CAPTURE phase so we run BEFORE that handler: for bundle lines
 * we cancel it and remove every line sharing the same `_bundle` id in one
 * /cart/update.js request.
 */
(function () {
  // Guard against double initialization (script is loaded from two places).
  if (window.__bundleCartInit) return;
  window.__bundleCartInit = true;

  const Fox = window.FoxTheme;

  /** Collect the sections the theme wants re-rendered (main cart / cart drawer). */
  function getSectionsToRender() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  async function removeBundle(bundleId) {
    // Read the current cart to find every line item key in this bundle.
    const cart = await (await fetch(`${Fox.routes.cart_url}`, { ...Fox.utils.fetchConfig() })).json();

    const updates = {};
    cart.items.forEach((item) => {
      if (item.properties && item.properties._bundle === bundleId) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return;

    const body = JSON.stringify({
      updates,
      sections: getSectionsToRender(),
      section_url: window.location.pathname,
    });

    const parsedState = await (
      await fetch(`${Fox.routes.cart_update_url}`, { ...Fox.utils.fetchConfig(), body })
    ).json();

    // Let the theme's <cart-items>/<cart-drawer> subscribers re-render themselves.
    Fox.pubsub.publish(Fox.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: 'bundle-cart',
      cart: parsedState,
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const removeButton = event.target.closest('[is="cart-remove-item"][data-bundle-id]');
      if (!removeButton) return;

      const bundleId = removeButton.getAttribute('data-bundle-id');
      if (!bundleId) return;

      // Stop the theme's single-line remove handler and the <a> navigation.
      event.preventDefault();
      event.stopImmediatePropagation();

      removeBundle(bundleId).catch((error) => {
        console.error('Bundle removal failed:', error);
        window.location.reload();
      });
    },
    true // capture phase: run before cart.js's own listener
  );
})();
